import { MarketingVideoTrayFormViewModel } from './marketing-video-tray-form.view-model';
import { MarketingVideoTrayDomainModel } from './marketing-video-tray.domain-model';
import { mapperPipe, PlatformType, remainderMapper } from 'osn-shared';
import {
  commonMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';
import {
  commonMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameMapper,
  platformTargetingMapper,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
  videoSourceMapperApiToDomain,
  videoSourceMapperDomainToApi,
  videoURLMapper,
} from '../../mapping/create-tray-domain-to-api';
import { CreateMarketingVideoPageItemApiModel, MarketingVideoPageItemApiModel } from '@cxb/editor-stb-api/model/models';
import { commonMapper, scheduledDateMapperApiToDomain, targetingMapperApiToDomain } from '../../mapping/create-tray-api-to-domain';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';

export const mapMarketingVideoTrayViewModelToDomainModel = (vm: MarketingVideoTrayFormViewModel): MarketingVideoTrayDomainModel => {
  const commonProperties = mapperPipe(
    vm,
    commonMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    platformTargetingMapper
  );
  const { image, name, videoSource, videoUrl } = vm;

  return remainderMapper(commonProperties, () => ({
    type: 'MarketingVideoTray',
    image,
    name,
    videoSource,
    videoUrl,
  }));
};

export const mapMarketingVideoTrayDomainModelToViewModel = (item: MarketingVideoTrayDomainModel): MarketingVideoTrayFormViewModel => {
  const commonProperties = mapperPipe(
    item,
    commonMapperDomainToViewModel,
    nameMapper,
    platformTargetingMapper,
    videoURLMapper,
    scheduledDateMapperDomainToViewModel
  );

  return remainderMapper(commonProperties, () => ({
    image: item.image,
    videoSource: item.videoSource,
    userSegmentIds: item.userSegmentIds,
    countryIds: item.countryIds,
    type: TrayFormViewModelType.MarketingVideoTray,
  }));
};

export const mapMarketingVideoTrayDomainModelToApiModel = (
  item: MarketingVideoTrayDomainModel,
  pageVersionId?: string,
  tenantId?: string
): CreateMarketingVideoPageItemApiModel => {
  const commonProperties = mapperPipe(
    item,
    nameMapper,
    videoSourceMapperDomainToApi,
    targetingMapperDomainToApi,
    scheduledDateMapperDomainToApi,
    platformTargetingMapper,
    videoURLMapper
  );

  return remainderMapper(commonProperties, () => ({
    imageId: item.image.WEB.en.id,
    pageVersionId,
    tenantId,
  }));
};

export const mapMarketingVideoTrayApiModelToDomainModel = (pageItem: MarketingVideoPageItemApiModel): MarketingVideoTrayDomainModel => {
  const commonProperties = mapperPipe(
    pageItem,
    commonMapper,
    nameMapper,
    videoSourceMapperApiToDomain,
    targetingMapperApiToDomain,
    scheduledDateMapperApiToDomain,
    platformTargetingMapper,
    videoURLMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'MarketingVideoTray',
    image: pageItem.image
      ? {
          [PlatformType.Web]: {
            en: {
              id: pageItem.image.id,
              name: pageItem.image.originalName,
              publicUrl: pageItem.image.publicUrl,
            },
          },
        }
      : undefined,
  }));
};
